import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './css/modalTheme.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// Registro del service worker para PWA
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/serviceWorker.js')
            .then(registration => {
                // Service worker registrado exitosamente
                // console.log('ServiceWorker registrado con scope:', registration.scope);
            })
            .catch(error => {
                // Error al registrar el service worker
                // console.log('Error al registrar ServiceWorker:', error);
            });
    });
}

/* <React.StrictMode></React.StrictMode> */